import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import Icon from '../atoms/Icon';

//Returning the component
class Modal extends Component {
	render() {
		return (
			<div className={`modal ${this.props.modalClass}`}>
				<div className={`modal__content ${this.props.modalContentClass}`}>
					<Icon classType={`modal__icon icon--button fa-2x fa-close ${this.props.modalIcon}`} role="button" onClick={this.props.onClick}/>
					{this.props.children}
				</div>
			</div>
		)
	}
}

//Default properties if they are not set
Modal.defaultProps = {
	modalClass: ""
};

export default Modal;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Modal.jsx